// extracted by mini-css-extract-plugin
module.exports = {"genericErrorWrapper":"ErrorBoundary_genericErrorWrapper__hhQmp","Container":"ErrorBoundary_Container__MsvIF"};